var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
var Redo = function Redo(props) {
  return React.createElement(
    Icon,
    _extends({ viewBox: '0 0 15 15' }, props),
    React.createElement(
      'g',
      null,
      React.createElement('path', { d: 'M15.047 7.026l-3.85 3.751-3.848-3.75.965-.717 2.917 2.583V5.886C11.23 3.237 8.94 1 6.23 1s-5 2.237-5 4.886v8.783h-1V5.886C.23 2.64 2.92 0 6.23 0c3.309 0 6 2.64 6 5.886v3.007l2.384-2.583.432.716z',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

export default Redo;
//# sourceMappingURL=Redo.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Icons/dist/components/Redo.js